import { render } from "./TimeTableSuggest.vue?vue&type=template&id=1c6e9c1b&scoped=true"
import script from "./TimeTableSuggest.vue?vue&type=script&lang=js"
export * from "./TimeTableSuggest.vue?vue&type=script&lang=js"

import "./TimeTableSuggest.vue?vue&type=style&index=0&id=1c6e9c1b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6e9c1b"]])

export default __exports__